module.exports = __webpack_public_path__ + "img/SpeakandPerform.77ca4100.png";